import {Injectable} from '@angular/core';
import {EventTrackingService} from "../../core/_services/event-tracking.service";
import {UtilitiesService} from "../../core/_services/utilities.service";
import {UserService} from "../../core/_services/user.service";
import {of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../../core/_services/auth.service";
import {Observable} from "rxjs/Rx";

@Injectable({
    providedIn: 'root'
})
export class CampaignEventsService {

    private _partnerId: number;
    private _landingPageDetailId: number;

    landingPage: boolean;
    landingPageDetail: any;

    // set only, no need to read
    set partnerId(value: number) {
        this._partnerId = value;
    }

    // set only, no need to read
    set landingPageDetailId(value: number) {
        this._landingPageDetailId = value;
    }

    constructor(private eventTrackingService: EventTrackingService,
                private userService: UserService,
                private authService: AuthService,
                private utilitiesService: UtilitiesService,
                private http: HttpClient) {
    }

    logBookingFlowStep(step: string): void {
        this.logEvent("Booking Flow Step", {step: step});
    }

    logZipEntered(zip: string): void {
        this.logEvent("Zip Entered", {zip: zip});
    }

    logVinEntered(vin: string): void {
        this.logEvent("VIN Entered", {vin: vin});
    }

    logLicenseEntered(license: any): void {
        this.logEvent("License Entered", {license: license});
    }

    logFirstAvailability(firstAvailableDate: string): void {
        this.logEvent("First Available Date", {date: firstAvailableDate});
    }

    logBookedJob(jobRequestId: number): void {
        this.logEvent("Booked Job", {jobRequestId: jobRequestId});
    }

    utmParams(): string {

        const source = this.utilitiesService.getLocal("utm_source");
        const medium = this.utilitiesService.getLocal("utm_medium");
        const term = this.utilitiesService.getLocal("utm_term");
        const campaign = this.utilitiesService.getLocal("utm_campaign");
        const content = this.utilitiesService.getLocal("utm_content");
        const gclid = this.utilitiesService.getLocal("gclid");
        const fbclid = this.utilitiesService.getLocal("fbclid");

        return "" +
            (UtilitiesService.isNotEmpty(source) ? "utm_source=" + source + "&" : "") +
            (UtilitiesService.isNotEmpty(medium) ? "utm_medium=" + medium + "&" : "") +
            (UtilitiesService.isNotEmpty(term) ? "utm_term=" + term + "&" : "") +
            (UtilitiesService.isNotEmpty(campaign) ? "utm_campaign=" + campaign + "&" : "") +
            (UtilitiesService.isNotEmpty(content) ? "utm_content=" + content + "&" : "") +
            (UtilitiesService.isNotEmpty(term) ? "utm_term=" + term + "&" : "") +
            (UtilitiesService.isNotEmpty(gclid) ? "gclid=" + gclid + "&" : "") +
            (UtilitiesService.isNotEmpty(fbclid) ? "fbclid=" + fbclid + "&"  : "");
    }

    private logEvent(eventName: string, metadata: any): void {
        const userData = this.userService.getCurrentUserData();
        try {
            const params = {
                eventName: eventName,
                metadata: btoa(JSON.stringify(metadata)),
                partnerId: this._partnerId,
                landingPageDetailId: this._landingPageDetailId,
                userId: userData.id,
                prospectId: this.eventTrackingService.prospectId,
                persistentKey: this.eventTrackingService.persistentKey,
                sessionKey: this.eventTrackingService.sessionKey
            };
            this.addCampaignEvent(params).subscribe();
        } catch (e) {
            UtilitiesService.consoleLog(e);
        }
    } // logEvent()

    private addCampaignEvent(params: any): Observable<any> {
        const endpoint = this.authService.loggedIn() ? "/job/addcampaigneventauthed" : "/job/addcampaignevent";
        const headers = this.authService.loggedIn() ? this.authService.getAuthHeaders() : this.authService.getBasicAuthHeaders();
        return this.http.post(
            this.authService.getBackendUrl(endpoint),
            JSON.stringify(params),
            headers
        ).catch((e) => {
            // we're ignoring errors on event calls
            UtilitiesService.consoleLog(e);
            return of({});
        });
    } // addCampaignEvent()

}
